module.exports = __webpack_public_path__ + "static/008071-9abe6e0efea5c9ad9fb2db9b8169aa29.jpg";